//import Alert from "react-s-alert";
import PropTypes from 'prop-types';
import Loader from 'react-loader-spinner';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Form, Image, Modal, Row } from 'react-bootstrap';
import Scrollbars from 'react-custom-scrollbars';
import SVG from 'react-inlinesvg';
import Media from 'react-media';
import { connect, useDispatch } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import Alert from 'react-s-alert';
import ButtonsYesNo from '../../../../../../vendorDashboardComponents/notification/ButtonsYesNo';
import { update_new_subscription_for_vendor } from '../../../../../../../store/actions/authAction';
import { reorder_menu_category_item } from '../../../../../../../store/actions/onboardingAction';
import {
  admin_get_chain_catalog,
  admin_get_global_catalog,
} from '../../../../../../../store/actions/SuperAdminActions/adminCreateCatalogue';
import {
  get_category_menu_setup,
  vendor_create_local_catalog_chain,
  vendor_create_local_catalog_global,
  fetch_menu_from_pos,
} from '../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import {
  ACTIVE_CATALOG_ID,
  ACTIVE_CATALOG_NAME,
  SET_ACTIVE_CATEGORY_DATA_MENU_SETUP,
  UPDATE_SUBSCRIPTION_TYPE,
  REORDER_VENDOR_MENU_CATEGORY,
  REORDER_VENDOR_MENU_ITEM,
  ACTIVE_MENU,
} from '../../../../../../../store/types';
import { AmealioLoader } from '../../../../../../Loader/AmealioLoader';
import { MobileTopHeader } from '../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader';
import { SliderMobileReusableComponent } from '../../../../../../reusableComponents/sliderReusableComponent/SliderMobileReusableComponent';
import { SliderReusableComponent } from '../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent';
import { BackLogoIconButton } from '../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText';
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from '../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
import { TopTextReusableComponent } from '../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent';
import MenuSetupItem from './MenuSetupItem';
import store from '../../../../../../../store/store';
import isEmpty from '../../../../../../../store/validation/is-Empty';
import DragAndDropItem from './DragAndDropMenuItem/DragAndDropItem';
import { get_list_of_custom_menu_data } from '../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionPostAction';
import { propTypes } from 'react-bootstrap/esm/Image';

const CustomMenus = [
  {
    name: 'Birthday Menu',
    description: 'A special menu for birthday celebrations',
  },
  {
    name: 'Custom Menu Two',
    description: 'A unique menu tailored to your tastes',
  },
  {
    name: 'Anniversary Menu',
    description: 'Celebrate your anniversary with a romantic menu',
  },
  {
    name: 'Holiday Feast',
    description: 'A festive menu perfect for holiday gatherings',
  },
  {
    name: 'Summer Barbecue',
    description: 'Enjoy a classic summer barbecue menu',
  },
  {
    name: 'Vegetarian Delight',
    description: 'A delightful menu for vegetarian lovers',
  },
  {
    name: 'Seafood Extravaganza',
    description: 'A menu filled with a variety of seafood dishes',
  },
  { name: 'Kids Special', description: 'A fun and tasty menu for kids' },
  {
    name: 'Healthy Choices',
    description: 'A menu focusing on healthy and nutritious options',
  },
  {
    name: 'Italian Cuisine',
    description: 'A menu featuring classic Italian dishes',
  },
  {
    name: 'Mexican Fiesta',
    description: 'A vibrant menu with authentic Mexican flavors',
  },
  {
    name: 'Asian Fusion',
    description: 'A menu combining flavors from various Asian cuisines',
  },
  {
    name: 'Comfort Food',
    description: 'A menu filled with heartwarming comfort foods',
  },
  {
    name: 'Gourmet Experience',
    description: 'A high-end gourmet menu for special occasions',
  },
  {
    name: 'Brunch Bonanza',
    description: 'A delicious brunch menu to start your day',
  },
  {
    name: 'Dessert Heaven',
    description: 'A menu dedicated to decadent desserts',
  },
  {
    name: 'Gluten-Free Options',
    description: 'A menu with tasty gluten-free dishes',
  },
  {
    name: 'Vegan Variety',
    description: 'A diverse menu with vegan-friendly dishes',
  },
  {
    name: 'Cocktail Party',
    description: 'A menu perfect for cocktail parties and gatherings',
  },
  {
    name: 'Street Food',
    description: 'A menu inspired by popular street food from around the world',
  },
];

const MenuSetup = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  console.log('props', props);
  //state
  const [showModel, setShowModel] = useState(false);
  const [showChain, setShowChain] = useState(false);
  const [showGloble, setShowGloble] = useState(false);
  const [switchMenu, setswitchMenu] = useState(false);
  const [showSubCategory, setShowSubCategory] = useState(false);
  const [showEditSubCategory, setShowEditSubCategory] = useState(false);
  const [state, setState] = useState({
    code: '',
    country: '',
    state: '',
    role: '',

    monday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 10),
        closing_time: new Date(2020, 1, 1, 12),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 16),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 19),
        closing_time: new Date(2020, 1, 1, 22),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 10),
          closing_time: new Date(2020, 1, 1, 12),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 16),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 19),
          closing_time: new Date(2020, 1, 1, 22),
          description: 'Dinner',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 24),
          closing_time: new Date(2020, 1, 1, 4),
          description: 'Midnight Munching',
        },
      ],
    },
    tuesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    wednesday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    thursday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    friday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    saturday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
    sunday: {
      open: false,
      breakfast: {
        open: false,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 11),
      },
      lunch: {
        open: false,
        opening_time: new Date(2020, 1, 1, 13),
        closing_time: new Date(2020, 1, 1, 15),
      },
      dinner: {
        open: false,
        opening_time: new Date(2020, 1, 1, 17),
        closing_time: new Date(2020, 1, 1, 23),
      },
      multipleHours: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: 'Breakfast',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: 'Lunch',
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: 'Dinner',
        },
      ],
    },
  });
  const [customMenuList, setCustomMenuList] = useState([]);
  const [activeMenu, setActiveMenu] = useState(null);
  const [showMenu, setShowMenu] = useState(props?.menuCategory);
  const handleShowChain = () => setShowChain(true);
  const handleCloseChain = () => setShowChain(false);
  const handleShowGloble = () => setShowGloble(true);
  const handleCloseGloble = () => setShowGloble(false);
  const handleSwitchMenu = () => setswitchMenu(true);
  const handleCloseSwitchMenu = () => setswitchMenu(false);

  useEffect(() => {
    if (props.customMenuList) {
      const updatedList = [
        {
          name: 'Standard menu',
          description: 'Standard Menu',
          _id: '123456',
          menuType: 'CUSTOM',
        },
        ...props.customMenuList,
      ];
      setCustomMenuList(updatedList);
    }
  }, [props.customMenuList]);

  const handleFetchMenu = () => {
    // const token = props.auth.user.accessToken;
    // props.fetch_menu_from_pos(token)

    setShowModel(true);
  };
  const handleCloseModal = () => {
    setShowModel(false);
  };
  const handleFetchYes = () => {
    const token = props.auth.user.accessToken;
    props.fetch_menu_from_pos(token);

    props.get_category_menu_setup(token, onSuccessStepLoader);
    handleCloseModal();
  };

  const onHandleReorderMenu = () => {
    let token = props.auth.user.accessToken;
    let menuCategoryData = props?.menuCategory;
    let AllItem = props?.reorderMenuCategoryItem;
    let AllItemDataStatus = props?.reorderMenuCategoryItemStatus.status;
    let formData = props?.reorderMenuCategory;
    let separateCatIdItemId = [];
    if (AllItemDataStatus) {
      for (let i = 0; i < menuCategoryData.length; i++) {
        let itemsId = [];
        for (let j = 0; j < menuCategoryData[i].items.length; j++) {
          itemsId.push({ _id: menuCategoryData[i].items[j]._id });
        }
        let dataCatObj = {
          _id: menuCategoryData[i]._id,
          items: itemsId,
        };
        separateCatIdItemId.push(dataCatObj);
      }
    } else {
      if (formData) {
        for (let i = 0; i < formData.length; i++) {
          let itemsId = [];
          for (let j = 0; j < formData[i].items.length; j++) {
            itemsId.push({ _id: formData[i].items[j]._id });
          }
          let dataCatObj = {
            _id: formData[i]._id,
            items: itemsId,
          };
          separateCatIdItemId.push(dataCatObj);
        }
      }
    }
    // console.log("separateCatIdItemId ===>", separateCatIdItemId);
    // return separateCatIdItemId.toString();
    dispatch(
      reorder_menu_category_item(separateCatIdItemId, token, (data) =>
        onSuccessReorderMenu(data)
      )
    );
  };

  const onSuccessReorderMenu = (data) => {
    let token = props.auth.user.accessToken;
    props.get_category_menu_setup(token, onSuccessStepLoader);
    Alert.success(`<h4>${data?.data?.message}</h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    store.dispatch({
      type: REORDER_VENDOR_MENU_CATEGORY,
      payload: [],
    });
    store.dispatch({ type: REORDER_VENDOR_MENU_ITEM, payload: [] });
    window.location.reload();
  };

  const HandleMenuSelection = (item) => {
    if (item._id === '123456') {
      setActiveMenu(null);
    } else {
      setActiveMenu(item);
    }
  };

  const SetCustomMenu = (item) => {
    dispatch({
      type: ACTIVE_MENU,
      payload: item,
    });
    handleCloseSwitchMenu();
  };

  useEffect(() => {
    if (props.ActiveMenu) {
      setShowMenu(
        props?.menuCategory.filter((i) => i.menu === props?.ActiveMenu?._id)
      );
    } else {
      setShowMenu(props?.menuCategory.filter((i) => !i.hasOwnProperty('menu')));
    }
  }, [props.menuCategory, props.ActiveMenu]);

  useEffect(() => {
    if (history?.location?.state?.globalmenu) handleShowGloble();
    if (history?.location?.state?.chainMenu) handleShowChain();
    if (history?.location?.state) {
      let state = { ...history?.location?.state };
      delete state?.globalmenu;
      delete state?.chainMenu;
      history.replace({ ...history.location, state });
    }
  }, [
    history?.location?.state?.globalmenu,
    history?.location?.state?.chainMenu,
  ]);

  const takeToCategoryEditPage = (data) => {
    dispatch({ type: SET_ACTIVE_CATEGORY_DATA_MENU_SETUP, payload: '' });
    if (history.location.pathname.includes('fastfood/menusetup')) {
      history.push('/fastfood/menusetup/addcategory');
    } else if (history.location.pathname.includes('multi-service/menusetup')) {
      history.push('/multi-service/menusetup/addcategory');
    } else if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push('/addcategory');
    } else {
      history.push('/casual-fine-dining/menusetup/addcategory');
    }
  };

  const navigateToCreateCombos = () => {
    history.push('/createcombos');
  };
  const onSuccess = () => {
    Alert.success(`<h4>Menu Setup Sucessfully </h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    if (
      props.auth.user.VendorUser.has_admin_approved &&
      props.auth.user.VendorUser.have_vendor_submitted_details
    ) {
      history.push('/itemavailablitydashboard');
    } else {
      if (history.location.pathname.includes('fastfood/menusetup')) {
        const formData = {
          casualDiningManagement: false,
          fastFoodOthersManagement: true,
          hospitalityAndHotelsManagement: false,
          multiSelectServices: false,
        };
        store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
      } else if (
        history.location.pathname.includes('multi-service/menusetup')
      ) {
        const formData = {
          casualDiningManagement: false,
          fastFoodOthersManagement: false,
          hospitalityAndHotelsManagement: false,
          multiSelectServices: true,
        };
        store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
      } else {
        const formData = {
          casualDiningManagement: true,
          fastFoodOthersManagement: false,
          hospitalityAndHotelsManagement: false,
          multiSelectServices: false,
        };
        store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
      }
      history.push('/subscription');
    }
  };

  const takeToSubscription = () => {
    //

    let checkIfEmpty = true;
    for (let i = 0; i < props.menuCategory.length; i++) {
      if (props.menuCategory[i].items.length > 0) {
        checkIfEmpty = false;
        break;
      }
    }
    if (checkIfEmpty) {
      Alert.error(`<h4>Please setup Menu First </h4>`, {
        position: 'top-right',
        effect: 'bouncyflip',
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const formData = props.allSubscriptionData;
      if (
        history.location.pathname.includes('fastfood/menusetup') ||
        (props.serviceType && props.serviceType.fast_food_dining)
      ) {
        formData.fast_food_dining_status.menu_setup.value = true;
      } else if (
        history.location.pathname.includes('multi-service/menusetup') ||
        (props.serviceType && props.serviceType.multi_service_business)
      ) {
        formData.multi_service_business_status.menu_setup.value = true;
      } else {
        formData.casual_dining_status.menu_setup.value = true;
      }

      //formData.casual_dining_status.seating.table_management.table_setup = values;

      const token = props.auth.user.accessToken;
      const subscriptionId = props.subscription._id;
      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    }
  };

  const backButtonHandler = (e) => {
    e.preventDefault();
    if (history.location.pathname.includes('fastfood/menusetup')) {
      const formData = {
        casualDiningManagement: false,
        fastFoodOthersManagement: true,
        hospitalityAndHotelsManagement: false,
        multiSelectServices: false,
      };
      store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
      setFormShow(false);
      history.push('/subscription');
    } else if (history.location.pathname.includes('multi-service/menusetup')) {
      const formData = {
        casualDiningManagement: false,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: false,
        multiSelectServices: true,
      };
      store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
      history.push('/subscription');
      setFormShow(false);
    } else {
      const formData = {
        casualDiningManagement: true,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: false,
        multiSelectServices: false,
      };
      store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
      history.push('/subscription');
      setFormShow(false);
    }
  };

  console.log(showMenu);
  // catalog starts

  const [searchChainCatalog, setSearchChainCatalog] = useState('');
  const [searchGlobalCatalog, setSearchGlobalCatalog] = useState('');

  var filteredChainCatalog = props.allChainCatalog.filter((item) => {
    return item.name.toLowerCase().includes(searchChainCatalog.toLowerCase());
  });
  filteredChainCatalog = filteredChainCatalog.filter((item) => {
    return item.status;
  });

  var filteredGlobalCatalog = props.allGLobalCatalog.filter((item) => {
    return item.name.toLowerCase().includes(searchGlobalCatalog.toLowerCase());
  });
  filteredGlobalCatalog = filteredGlobalCatalog.filter((item) => {
    return item.status;
  });

  const onDisplayCategory = () => {
    let filteredData = props?.menuCategory;

    // filteredData = props?.menuCategory.sort((a, b) => {
    //   if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    //   if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    //   return 0;
    // });

    if (!isEmpty(filteredData)) {
      return (
        filteredData &&
        filteredData.map((category, index) => {
          return (
            <React.Fragment key={index}>
              {!category.is_temp_local ? (
                <MenuSetupItem category={category} disabled={disabled} />
              ) : (
                <> </>
              )}
              {/* <MenuSetupItem
                key={index}
                category={category}
                disabled={disabled}
              /> */}
            </React.Fragment>
          );
        })
      );
    } else {
      return null;
    }
  };

  const [chainCatalogId, setChainCatalogId] = useState('');
  const [globalCatalogId, setGlobalCatalogId] = useState('');

  const setChainCatalogIdName = (id, name) => {
    setChainCatalogId(id);
    dispatch({ type: ACTIVE_CATALOG_NAME, payload: name });
    dispatch({ type: ACTIVE_CATALOG_ID, payload: id });
  };

  const setGlobalCatalogIdName = (id, name) => {
    setGlobalCatalogId(id);
    dispatch({ type: ACTIVE_CATALOG_NAME, payload: name });
    dispatch({ type: ACTIVE_CATALOG_ID, payload: id });

    console.log('id', id);
    console.log('name', name);
  };

  const onSuccessGetCategoryData = () => {
    if (props.dash) {
      // history.push("/selectedcategories");
      history.push('/selectitemsnew');
    } else {
      history.push(
        '/casual-fine-dining/menusetup/selectmenu/selectedcategories'
      );
    }
  };

  const redirectToCategories = (type) => {
    if (chainCatalogId === '' && type === 'chain') {
      Alert.error(`<h4>Please select catalog </h4>`, {
        position: 'top-right',
        effect: 'bouncyflip',
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (globalCatalogId === '' && type === 'global') {
      Alert.error(`<h4>Please select catalog </h4>`, {
        position: 'top-right',
        effect: 'bouncyflip',
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const token = props.auth.user.accessToken;
      if (type === 'global') {
        props.vendor_create_local_catalog_global(
          token,
          globalCatalogId,
          onSuccessGetCategoryData
        );
      } else {
        props.vendor_create_local_catalog_chain(
          token,
          chainCatalogId,
          onSuccessGetCategoryData
        );
      }
    }
  };
  // catalog end
  const [loading, setLoading] = useState(false);
  const onSuccessStepLoader = () => {
    setLoading(false);
  };
  useEffect(() => {
    setLoading(true);
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token, onSuccessStepLoader);
    props.admin_get_global_catalog(token);
    props.admin_get_chain_catalog(token);
  }, []);

  useEffect(() => {
    if (props.serviceType.vendor_id) {
      props.get_list_of_custom_menu_data(props?.serviceType?.vendor_id);
    }
  }, [props?.serviceType]);

  const [formShow, setFormShow] = useState(false);
  const handleFormShow = () => {
    setFormShow(true);
  };
  const handleFormHide = () => {
    setFormShow(false);
  };
  const [disabled, setDisable] = useState(
    props &&
      props.history &&
      props.history.location &&
      props.history.location.state &&
      props.history.location.state.access === 'view'
      ? true
      : false
  );

  console.log(activeMenu);

  useEffect(() => {
    if (props.menuCategory.length > 0) {
      setFormShow(true);
    } else {
      setFormShow(false);
    }
  }, [props.menuCategory]);

  const getTotalItemsCount = (data) => {
    let totalActiveItem = [];
    if (data !== undefined && data !== null && data.length > 0) {
      let categoryItem = [];
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].items.length; j++) {
          if (data[i].items[j].currentState === 9) {
            categoryItem.push(data[i].items[j]);
          }
        }
      }
      totalActiveItem.push(...categoryItem);
    }
    return totalActiveItem && totalActiveItem.length;
  };

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <Media query="(max-width: 991px)">
            <>
              {!formShow && (
                <div className="bg-white min-height-100vh position-relative">
                  <div className="mobileFirstScreen col-12">
                    <SliderMobileReusableComponent
                      // backLink={true}
                      //onLink={"/subscription"}
                      onClick={(e) => backButtonHandler(e)}
                      paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                      paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                      paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                      bottomImage={require('../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg')}
                    />
                  </div>
                  <div className="col-12 py-4 d-flex justify-content-between">
                    <div className="f24_700_HelveticaNeue">Menu Set Up</div>
                    <div></div>
                  </div>
                  <div className="border-top d-flex justify-content-center align-items-center p-3 fixed-bottom bg-white">
                    <ReusableOnboardingLink
                      buttonTitle="Back Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      buttonText="Back"
                      link={'/subscription'}
                    />
                    <ReusableOnboardingButton
                      buttonType="button"
                      buttonTitle="Next"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Next"
                      onClick={handleFormShow}
                    />
                  </div>
                </div>
              )}
            </>
          </Media>
          {props.dash ? (
            <div className="mobile-pb-150 menuSetupscreen d-flex justify-content-between flex-column">
              <Row
                className={`align-items-center ${!props.dash && `justify-content-between`
                  } pb-4 py-md-4 mr-3`}
              >
                <Col md={12} className="pb-4 d-flex justify-content-between">
                  <TopTextReusableComponent
                    headingText={
                      props?.ActiveMenu
                        ? props?.ActiveMenu?.name + ' Set UP'
                        : `Standard Menu Set Up`
                    }
                    headingParagraph={
                      props?.ActiveMenu
                        ? props?.ActiveMenu?.description
                        : `Manage your food items`
                    }
                    disabled={disabled}
                  />
                  <div className="d-flex">
                    <div
                      className="f14-700  mx-2"
                      onClick={() => handleSwitchMenu()}
                    >
                      Switch Menu{' '}
                      <Image
                        src={require('../../../../../../../assets/images/Icon/Refresh.png')}
                        width={'22px'}
                      />
                      |
                    </div>
                    <div
                      className="f14-700"
                      onClick={() => history.push('/createcustommenu')}
                    >
                      Create Menu
                      <i
                        class="fa fa-plus-circle mx-2"
                        aria-hidden="true"
                        style={{ fontSize: '22px' }}
                      ></i>
                    </div>
                  </div>
                </Col>
                <Col md={4} lg={2}>
                  <Button
                    variant="outline-danger"
                    className="btn-md btnf12_400_HelveticaNeue btn3graup"
                    onClick={handleShowGloble}
                    disabled={
                      props.onboarding?.restaurantDetails?.pos?.restId !== ''
                        ? !disabled
                        : disabled
                    }
                  >
                    Select Categories &nbsp;
                    <br />
                    From Global Menu
                  </Button>
                </Col>
                <Col md={4} lg={2}>
                  <Button
                    variant="outline-danger"
                    className="btn-md btnf12_400_HelveticaNeue btn3graup btn btn-outline-danger"
                    onClick={() => takeToCategoryEditPage()}
                    disabled={
                      props.onboarding?.restaurantDetails?.pos?.restId !== ''
                        ? !disabled
                        : disabled
                    }
                  >
                    Add Custom &nbsp;
                    <br />
                    Categories
                  </Button>
                </Col>
                <Col md={4} lg={2}>
                  <Button
                    variant="outline-danger"
                    className="btn-md btnf12_400_HelveticaNeue btn3graup"
                    onClick={handleShowChain}
                    disabled={
                      props.onboarding?.restaurantDetails?.pos?.restId !== ''
                        ? !disabled
                        : disabled
                    }
                  >
                    Add From Chain &nbsp;
                    <br />
                    Categories
                  </Button>
                </Col>
                <Col md={4} lg={2}>
                  <Button
                    variant="outline-danger"
                    className="btn-md btnf12_400_HelveticaNeue btn3graup"
                    onClick={navigateToCreateCombos}
                    disabled={false}
                  >
                    Add &nbsp;
                    <br />
                    Combos
                    <br />
                  </Button>
                </Col>
                <Col md={4} lg={3}>
                  <div className="f12-500">
                    Total Number of Items :{' '}
                    <span
                      className="f16-500 text-success"
                      style={{ verticalAlign: 'middle' }}
                    >
                      {getTotalItemsCount(showMenu)}
                    </span>
                  </div>
                </Col>
                <Col md={4} lg={3}>
                  {console.log(
                    props.onboarding?.restaurantDetails?.pos?.restId
                  )}
                  {props.onboarding?.restaurantDetails?.pos?.restId !== '' ? (
                    <Button
                      variant="danger"
                      className="btn-md btnf12_400_HelveticaNeue btn3graup"
                      onClick={handleFetchMenu}
                    >
                      Fetch Menu
                    </Button>
                  ) : null}
                </Col>
                <React.Fragment>
                  <Modal show={showModel} onHide={handleCloseModal} centered>
                    <Modal.Header className="py-0 pt-2 border-0" closeButton>
                      <Modal.Title className="f24-700">Fetch Menu</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="f14-400 pb-4">
                      This operation will remove all the existing categories and
                      items.<br></br>
                      Are you sure you want to fetch the menu?
                    </Modal.Body>

                    <Modal.Footer className="justify-content-start border-0">
                      <ButtonsYesNo
                        handleCloseModal={handleCloseModal}
                        onClearAllReadItem={handleFetchYes}
                      />
                    </Modal.Footer>
                  </Modal>
                </React.Fragment>
              </Row>
              <div className="f12-500 pb-4">
                Add all your Menu Categories to move ahead with the Menu Set Up
                Process
              </div>
              {props.menuCategory.length >= 2 && !disabled ? (
                <div className="d-flex justify-content-between">
                  <button
                    className="btn-xs btn btn-danger text-normal"
                    disabled={
                      props?.reorderMenuCategory.length > 0 ||
                        props?.reorderMenuCategoryItemStatus.status === true
                        ? false
                        : true
                    }
                    type="button"
                    title="Save Reorder Category"
                    onClick={onHandleReorderMenu}
                  >
                    Save Reorder Category
                  </button>
                  {props.dash ? (
                    <NavLink
                      to={`${'/menusetup/crossselling'}`}
                      className="btn-xs btn btn-danger text-normal"
                      disabled={disabled}
                    >
                      Cross-Selling
                    </NavLink>
                  ) : (
                    <NavLink
                      to={`${history?.location?.pathname?.includes(
                        'fastfood/menusetup'
                      )
                        ? '/fastfood/menusetup/crossselling'
                        : history?.location?.pathname?.includes(
                          'multi-service/menusetup'
                        )
                          ? '/multi-service/menusetup/crossselling'
                          : '/casual-fine-dining/menusetup/crossselling'
                        }`}
                      className="btn-xs btn btn-danger text-normal"
                      disabled={disabled}
                    >
                      Cross-Selling
                    </NavLink>
                  )}
                </div>
              ) : (
                <> </>
              )}
              <div
                className={`${showMenu?.length <= 0
                  ? 'enCategoryListOnboardingMain d-flex justify-content-center'
                  : 'enCategoryListOnboardingMain'
                  }`}
              >
                {/* {props?.menuCategory.map((category, index) => (
                  <Fragment key={index}>
                    {!category.is_temp_local ? (
                      <MenuSetupItem category={category} disabled={disabled} />
                    ) : (
                      <> </>
                    )}
                  </Fragment>
                ))} */}

                <DragAndDropItem menuCategory={showMenu} disabled={disabled} />
              </div>
              <div
                className="d-flex justify-content-end ml-5 ml-2 ml-xl-5 bottom-upload-menu-setup mt-3"
              // style={{ right: "53%", position: "fixed", bottom: "6%" }}
              >
                {!disabled && (
                  <NavLink
                    to="/casual-fine-dining/menusetup/uploadmenu"
                    className="f12-700 text-red cursor p-0 bg-transparent border-0"
                    disabled={disabled}
                  >
                    Upload Menu
                  </NavLink>
                )}
                <span className="f10-400 ml-2">
                  Leave Rest to us
                  <br />
                  Charges May Apply
                </span>
              </div>
              <div className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                <div>
                  {/* <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="btn-md btn btn-outline-secondary"
                    buttonText="Cancel"
                    //link="/subscription"
                    
                  /> */}
                  <ReusableOnboardingButton
                    buttonTitle="Back Button"
                    buttonClass="btn-md btn btn-outline-secondary"
                    buttonText="Cancel"
                    buttonType="button"
                    buttonStyle={{ width: '150px' }}
                    onClick={(e) => backButtonHandler(e)}
                  />

                  <ReusableOnboardingButton
                    buttonTitle="Submit Menu"
                    buttonClass="btn-md btn btn-danger btn-lg ml-3 "
                    buttonText="Set Up Done"
                    buttonType="Submit"
                    buttonStyle={{ width: '150px' }}
                    disabled={disabled}
                    onClick={() => takeToSubscription()}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div
              className={`container-fluid formShow ${formShow ? 'active' : ''}`}
            >
              <div className="row">
                <div
                  id="onboarding-scrollbar"
                  className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
                >
                  <Media query="(min-width: 992px)">
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        //backButtonClicked={"/subscription"}
                        backButtonClicked={(e) => backButtonHandler(e)}
                        notDisplaProgressBar={true}
                        workWithLinkORClick={true}
                      />
                    </div>
                  </Media>
                  <Media query="(max-width: 991px)">
                    <MobileTopHeader onClick={handleFormHide} />
                  </Media>
                  <div className="mobile-pb-150 menuSetupscreen onboarding_process_screen-button-map d-flex justify-content-between flex-column">
                    <Row className="align-items-center justify-content-between pb-4 py-md-4">
                      <Col md={12} className="pb-4">
                        <TopTextReusableComponent
                          headingText="Menu Set Up"
                          headingParagraph="Manage your food items"
                          disabled={disabled}
                        />
                        {props.onboarding?.restaurantDetails?.pos?.restId !==
                          '' ? (
                          <Button
                            variant="danger"
                            className="btn-md btnf12_400_HelveticaNeue btn3graup"
                            style={{ float: 'right' }}
                            onClick={handleFetchMenu}
                          >
                            Fetch Menus
                          </Button>
                        ) : null}
                        <React.Fragment>
                          <Modal
                            show={showModel}
                            onHide={handleCloseModal}
                            centered
                          >
                            <Modal.Header
                              className="py-0 pt-2 border-0"
                              closeButton
                            >
                              <Modal.Title className="f24-700">
                                Fetch Menu
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="f14-400 pb-4">
                              This operation will remove all the existing
                              categories and items.<br></br>
                              Are you sure you want to fetch the menu?
                            </Modal.Body>

                            <Modal.Footer className="justify-content-start border-0">
                              <ButtonsYesNo
                                handleCloseModal={handleCloseModal}
                                onClearAllReadItem={handleFetchYes}
                              />
                            </Modal.Footer>
                          </Modal>
                        </React.Fragment>
                      </Col>
                      <Col md={12}>
                        <div className="d-flex justify-content-end my-2">
                          <div
                            className="f14-700  mx-2"
                            onClick={() => handleSwitchMenu()}
                          >
                            Switch Menu{' '}
                            <Image
                              src={require('../../../../../../../assets/images/Icon/Refresh.png')}
                              width={'22px'}
                            />
                            |
                          </div>
                          <div
                            className="f14-700"
                            onClick={() =>
                              history.push('/createcustommenuonboard')
                            }
                          >
                            Create Menu
                            <i
                              class="fa fa-plus-circle mx-2"
                              aria-hidden="true"
                              style={{ fontSize: '22px' }}
                            ></i>
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <Button
                          variant="outline-danger"
                          className="btn-md btnf12_400_HelveticaNeue btn3graup"
                          onClick={handleShowGloble}
                          disabled={disabled}
                        >
                          Select Categories&nbsp;
                          <br />
                          From Global Menu
                        </Button>
                      </Col>
                      <Col md={4}>
                        <Button
                          className="btn-md btnf12_400_HelveticaNeue btn3graup btn btn-outline-danger"
                          onClick={() => takeToCategoryEditPage()}
                          disabled={disabled}
                        >
                          Add Custom&nbsp;
                          <br />
                          Categories
                        </Button>
                      </Col>
                      <Col md={4}>
                        <Button
                          variant="outline-danger"
                          className="btn-md btnf12_400_HelveticaNeue btn3graup"
                          onClick={handleShowChain}
                          disabled={disabled}
                        >
                          Add From Chain&nbsp;
                          <br />
                          Categories
                        </Button>
                      </Col>
                    </Row>
                    <div className="f12-500 pb-4">
                      Add all your Menu Categories to move ahead with the Menu
                      Set Up Process
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <button
                        className="btn-xs btn btn-danger text-normal"
                        disabled={
                          props?.reorderMenuCategory.length > 0 ||
                            props?.reorderMenuCategoryItemStatus.status === true
                            ? false
                            : true
                        }
                        type="button"
                        title="Save Reorder Category"
                        onClick={onHandleReorderMenu}
                      >
                        Save Reorder Category
                      </button>
                      <div className="f12-500">
                        Total Number of Items :{' '}
                        <span
                          className="f16-500 text-success"
                          style={{ verticalAlign: 'middle' }}
                        >
                          {getTotalItemsCount(showMenu)}
                        </span>
                      </div>
                      {props.menuCategory.length >= 2 && !disabled ? (
                        <NavLink
                          to="/casual-fine-dining/menusetup/crossselling"
                          className="btn-xs btn btn-danger text-normal"
                          disabled={disabled}
                        >
                          Cross-Selling
                        </NavLink>
                      ) : (
                        <> </>
                      )}
                    </div>

                    <div
                      className={`${showMenu?.length <= 0
                        ? 'enCategoryListOnboardingMain d-flex justify-content-center'
                        : 'enCategoryListOnboardingMain'
                        }`}
                    >
                      {showMenu?.length <= 0 ? (
                        <div className="col-1 p-0 d-flex align-items-center">
                          <Loader
                            type="ThreeDots"
                            color="#00BFFF"
                            height={39}
                            width={39}
                          />
                        </div>
                      ) : (
                        // onDisplayCategory()
                        <DragAndDropItem
                          menuCategory={showMenu}
                          disabled={disabled}
                        />
                      )}
                    </div>
                    <div
                      className="d-flex justify-content-end ml-5 ml-2 ml-xl-5 bottom-upload-menu-setup mt-3"
                    // style={{ right: "53%", position: "fixed", bottom: "6%" }}
                    >
                      {!disabled && (
                        <NavLink
                          to="/casual-fine-dining/menusetup/uploadmenu"
                          className="f12-700 text-red cursor p-0 bg-transparent border-0"
                          disabled={disabled}
                        >
                          Upload Menu
                        </NavLink>
                      )}
                      <span className="f10-400 ml-2">
                        Leave Rest to us
                        <br />
                        Charges May Apply
                      </span>
                    </div>
                    <div className="mobile-center onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                      <div>
                        {/* <ReusableOnboardingLink
                          buttonTitle="Back Button"
                          buttonClass="btn-md btn btn-outline-secondary"
                          buttonText="Cancel"
                          //link="/subscription"
                          onClick={(e) => backButtonHandler(e)}
                        /> */}
                        <ReusableOnboardingButton
                          buttonTitle="Back Button"
                          buttonClass="btn-md btn btn-outline-secondary"
                          buttonText="Cancel"
                          buttonType="button"
                          onClick={(e) => backButtonHandler(e)}
                        />
                        <ReusableOnboardingButton
                          buttonTitle="Submit Menu"
                          buttonClass="btn-md btn btn-danger btn-lg ml-3 "
                          buttonText="Set Up Done"
                          buttonType="Submit"
                          disabled={disabled}
                          onClick={() => takeToSubscription()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                  <SliderReusableComponent
                    // displayBarButton={false}
                    displayHamburger={true}
                    paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                    bottomImage={require('../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg')}
                  />
                </div>
              </div>
            </div>
          )}
          <Modal
            show={showGloble}
            onHide={handleCloseGloble}
            centered
            className="xl-width-750 selectCatalogueModal"
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div className="w-100">
                <Modal.Title className="f20-700 pb-2">
                  Global Catalogue
                </Modal.Title>
                <div className="d-flex mobileColumn justify-content-between">
                  <p className="f14-400">
                    Please select the catalogue menu you want to proceed with
                  </p>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    className="amSearch"
                    style={{ width: 180, backgroundColor: '#fff' }}
                    disabled={disabled}
                    value={searchGlobalCatalog}
                    onChange={(e) => setSearchGlobalCatalog(e.target.value)}
                  />
                </div>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4">
              <div className="enGlobleCatelogueModalListMain">
                <Scrollbars style={{ width: '100%', height: 280 }}>
                  {filteredGlobalCatalog.map((item, index) => (
                    <div className="d-flex align-items-center mb-4" key={index}>
                      {/* <Form.Check label="1" inline className="enCheckBoxOnly" /> */}
                      <label className="enRadioWithText small">
                        <input
                          type="radio"
                          name="ItemCode"
                          checked={globalCatalogId === item._id}
                          //onClick={() => setChainCatalogId(item._id)}
                          onClick={() =>
                            setGlobalCatalogIdName(item._id, item.name)
                          }
                        // onClick={() => setItemForCopy(item)}
                        />
                        <span className="checkmark"></span>
                      </label>

                      <div className="enGlobleCatelogueModalList d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-center">
                          <div className="enCatelogueIconDiv">
                            <SVG
                              width="27px"
                              src={require('../../../../../../../assets/images/UserManagement/menuicon.svg')}
                            />
                          </div>
                          <div className="f14-500 px-3">{item.name}</div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="f14-500 pr-3">ID : # {item._id}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Scrollbars>
              </div>
              <div className="d-flex mobile-center align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                  onClick={handleCloseGloble}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn150px btn-lg px-5"
                  disabled={disabled}
                  onClick={() => redirectToCategories('global')}
                >
                  Proceed
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={showChain}
            onHide={handleCloseChain}
            centered
            className="xl-width-750 selectCatalogueModal"
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div className="w-100">
                <Modal.Title className="f20-700 pb-2">
                  Chain Catalogue
                </Modal.Title>
                <div className="d-flex mobileColumn justify-content-between">
                  <p className="f14-400">
                    Please select the catalogue menu you want to proceed with
                  </p>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    className="amSearch"
                    style={{ width: 180, backgroundColor: '#fff' }}
                    value={searchChainCatalog}
                    onChange={(e) => setSearchChainCatalog(e.target.value)}
                  />
                </div>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4">
              <div className="enGlobleCatelogueModalListMain">
                <Scrollbars style={{ width: '100%', height: 280 }}>
                  {filteredChainCatalog.map((item, index) => (
                    <div className="d-flex align-items-center mb-4" key={index}>
                      {/* <Form.Check label="1" inline className="enCheckBoxOnly" /> */}
                      <label className="enRadioWithText small">
                        <input
                          type="radio"
                          name="ItemCode"
                          checked={chainCatalogId === item._id}
                          //onClick={() => setChainCatalogId(item._id)}
                          onClick={() =>
                            setChainCatalogIdName(item._id, item.name)
                          }
                        // onClick={() => setItemForCopy(item)}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <div className="enGlobleCatelogueModalList d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-center">
                          <div className="enCatelogueIconDiv">
                            <SVG
                              width="27px"
                              src={require('../../../../../../../assets/images/UserManagement/menuicon.svg')}
                            />
                          </div>
                          <div className="f14-500 px-3">{item.name}</div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="f14-500 pr-3">ID : # {item._id}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Scrollbars>
              </div>

              <div className="mobile-center d-flex align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                  onClick={handleCloseChain}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn150px btn-lg px-5"
                  onClick={() => redirectToCategories('chain')}
                >
                  Proceed
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={switchMenu}
            onHide={handleCloseSwitchMenu}
            centered
            className="xl-width-750 selectCatalogueModal"
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div className="w-100">
                <Modal.Title className="f20-700 pt-2">Select Menu</Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4">
              <div className="d-flex mobileColumn justify-content-between mx-4 mb-3">
                <p className="f14-400 ml-4">Menu Name</p>
                <p className="f14-400">Menu Description</p>
              </div>
              <div className="enGlobleCatelogueModalListMain">
                <Scrollbars style={{ width: '100%', height: 280 }}>
                  {customMenuList
                    ?.filter((i) => i.menuType === 'CUSTOM')
                    .map((item, index) => (
                      <div
                        className="d-flex align-items-center mb-4"
                        key={index}
                      >
                        {/* <Form.Check label="1" inline className="enCheckBoxOnly" /> */}
                        <label className="enRadioWithText small">
                          <input
                            type="radio"
                            name="ItemCode"
                            checked={
                              activeMenu?._id === item._id ||
                              (activeMenu == null && item._id === '123456')
                            }
                            onClick={() => HandleMenuSelection(item)}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <div className="border p-2 d-flex align-items-center justify-content-between w-100">
                          <div className="d-flex align-items-center">
                            {/* <div className="enCatelogueIconDiv">
                            <SVG
                              width="27px"
                              src={require('../../../../../../../assets/images/UserManagement/menuicon.svg')}
                            />
                          </div> */}
                            <div className="f14-500 px-3">{item?.name}</div>
                          </div>
                          <div className="d-flex align-items-center">
                            <div className="f14-500 pr-3">
                              {item?.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </Scrollbars>
              </div>
              <div className="d-flex mobile-center align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                  onClick={handleCloseSwitchMenu}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn150px btn-lg px-5"
                  disabled={disabled}
                  onClick={() => SetCustomMenu(activeMenu)}
                >
                  Confirm
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.redButton ? (
        <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
          <Image
            src={require('../../../../../../../assets/images/UserManagement/Delete.svg')}
            alt="Delete"
            title="Delete"
            fluid
          />
        </div>
      ) : (
        <button
          type="button"
          className="enBtnoutlineGrayIcon"
          onClick={handleShowBlockUser}
        >
          <SVG
            src={require('../../../../../../../assets/images/UserManagement/Delete.svg')}
          />
        </button>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleCloseBlockUser}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

MenuSetup.propTypes = {
  auth: PropTypes.object.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
  reorder_menu_category_item: PropTypes.func.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  customMenuList: PropTypes.object.isRequired,
  ActiveMenu: PropTypes.object.isRequired,
  // subscriptionData: PropTypes.object.isRequired,
  // allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  menuCategory: state.onboarding && state.onboarding.menuCategory,
  allSubscriptionData:
    state.onboarding && state.onboarding?.onboard_subscription_details,
  subscription:
    state.onboarding && state.onboarding?.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status
      .menu_setup,
  allGLobalCatalog: state.commonSuperAdmin.allGLobalCatalog,
  allChainCatalog: state.commonSuperAdmin.allChainCatalog,
  serviceType:
    state.onboarding && state.onboarding?.onboard_subscription_details,
  reorderMenuCategory:
    state.onboarding && state.onboarding?.reorder_menu_category_item,
  reorderMenuCategoryItem:
    state.onboarding && state.onboarding?.reorder_menu_item_data,
  reorderMenuCategoryItemStatus:
    state.onboarding && state.onboarding?.reorder_menu_item_data_status,
  onboarding: state.onboarding && state.onboarding,
  customMenuList: state?.onboarding?.get_custom_menu_list,
  ActiveMenu: state?.onboarding?.active_menu,
});

export default connect(mapStateToProps, {
  get_category_menu_setup,
  update_new_subscription_for_vendor,
  reorder_menu_category_item,
  admin_get_chain_catalog,
  admin_get_global_catalog,
  vendor_create_local_catalog_chain,
  vendor_create_local_catalog_global,
  fetch_menu_from_pos,
  get_list_of_custom_menu_data,
})(MenuSetup);
